// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import MediaPlayer from 'church-theme-library/components/MediaPlayer/MediaPlayer'
import Image from 'church-theme-library/components/Image/Image'
import { get } from 'church-theme-library/utilities/objects'

// Redux:
import { getLivestreamData, getVideosData } from 'church-theme-library/redux/actions/site'

class Livestream extends React.Component {
	constructor() {
		super()

		// const today = new Date()
		// this.isSaturday = today.getDay() == 6
	}

	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getLivestreamData() )
		dispatch( getVideosData() )
	}

	render() {
		const { contentId, sectionId, data, videos, livestream, livestreamReceived, youtubeURL, translate } = this.props
		let className = 'section-livestream'

		if ( ! livestreamReceived ) {
			className += ' is-loading'
		}

		const livestreamId = get( ['video_id'] )( livestream )
		let livestreamService = get( ['service'] )( livestream )
		let livestreamUrl = get( ['url'] )( livestream )
		let videoId = livestreamId

		if ( ! videoId && 'custom' != livestreamService ) {
			let latestVideoKey = ''
			const latestVideoKeys = Object.keys( get( ['recent'] )( videos, {} ) )

			if ( latestVideoKeys.length ) {
				latestVideoKey = latestVideoKeys[0]
				videoId = get( ['recent', latestVideoKey, 'video_id'] )( videos )
			}
		}

		if ( ! livestreamUrl && 'youtube' == livestreamService ) {
			livestreamUrl = youtubeURL
		}

		if ( ! videoId ) {
			className += ' without-video'
		}

		return (
			<div className={ className }>
				<div className="-inner">
					{ videoId &&
						<div className="-embed">
							<div className="iframe">
								<div className="iframe-inner">
									<iframe src={ `https://www.youtube-nocookie.com/embed/${videoId}?feature=oembed` } frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen="" />
								</div>
							</div>
						</div>
					}

					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="heading"
							content={ data.heading }
						/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		livestream: state.site.livestream,
		livestreamReceived: state.site.livestreamReceived,
		videos: state.site.videos,
		youtubeURL: state.site.youtubeURL
	}
}

export default localize(
	connect( mapStateToProps )( Livestream )
)
